import React, { Component } from "react";
import TemplateListItem from "../list-item/TemplateListItem";
import { connect } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import axios, { contentClient } from "../../AxiosClient";
import PubSub from "pubsub-js";
import { TEMPLATE_UPDATE, TEMPLATE_ADD } from "../../utils/Topics.js";

class TemplateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templates: [],
      instance: new Date().getTime().toString(),
      selected: {},
      loading: true,
    };
  }
  componentDidMount() {
    if (this.state.templates.length === 0) {
      this.getTemplates();
    }
    this.updateTemplate = PubSub.subscribe(TEMPLATE_UPDATE, (msg, data) => {
      let currentTemplates = this.state.templates.splice(0);
      if (this.state.selected.id === data.template.id) {
        this.setState({ selected: data.template });
        this.props.displayTemplate(data.template);
      }
      var reformattedArray = currentTemplates.map((template) => {
        if (template.id === data.template.id) {
          template = data.template;
          return template;
        } else {
          return template;
        }
      });
      this.setState({ templates: reformattedArray });
    });
    this.addTemplate = PubSub.subscribe(TEMPLATE_ADD, (msg, data) => {
      let newTemplates = this.state.templates.splice(0);
      newTemplates.push(data.template);
      this.setState({ templates: newTemplates });
    });
  }
  componentWillUnmount() {
    PubSub.unsubscribe(this.addTemplate);
    PubSub.unsubscribe(this.updateTemplate);
  }

  displayTemplate = (template) => {
    let newTemplate = JSON.parse(JSON.stringify(template));
    this.props.displayTemplate({ ...newTemplate });
    this.setState({ selected: { ...newTemplate } });
  };

  render() {
    return (
      <div>
        {this.state.loading ? (
          <>
            <div style={{ direction: "ltr" }}>
              {Array.from(Array(2)).map(() => {
                return (
                  <div style={{ marginTop: 4, marginBottom: 12 }}>
                    <Skeleton
                      variant="rect"
                      style={{ width: "35%", marginBottom: 5 }}
                      height={25}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{ width: "90%" }}
                      height={25}
                      animation="wave"
                    />
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <>
            {this.state.templates.map((template) => (
              <TemplateListItem
                deleteTemplates={this.deleteTemplates}
                instance={this.state.instance}
                displayTemplate={this.displayTemplate}
                template={template}
                selected={this.state.selected.id === template.id}
              />
            ))}
          </>
        )}
      </div>
    );
  }
  getTemplates() {
    contentClient.get("/template/").then((res) => {
      this.setState({ templates: res.data, loading: false });
    });
  }
  deleteTemplates = (template) => {
    let newTemplates = this.state.templates.splice(0);
    for (let i = 0; i < newTemplates.length; i++) {
      if (newTemplates[i].id === template) {
        newTemplates.splice(i, 1);
      }
    }
    this.setState({ templates: newTemplates });
    this.props.clearCurrent(template);
  };
}
const mapStateToProps = (state) => ({
  message: state.websocket.message,
});
export default connect(
  mapStateToProps,
  null
)(TemplateList);
